{
  "fr": {
    "materialGenerationPromptModal": {
      "buttons": {
        "generate": "Générer une proposition"
      },
      "description": "L'ébauche du {material} est basée sur le contenu de votre {sourceKind} et peut toujours être modifiée et enrichie.",
      "headers": {
        "fallbackTitle": "Créer du matériel avec l'IA",
        "title": "Créer {material} pour le {sourceKind} avec l'IA"
      },
      "labels": {
        "language": "Langue",
        "prompt": "Exigences"
      },
      "help": {
        "prompt": "Décrivez ici en plus le public cible, le contexte d'enseignement et le focus pour le {material}. Indiquez éventuellement la question directrice, l'objectif d'apprentissage ou des exigences particulières."
      },
      "placeholders": {
        "prompt": "Décris le public cible, le contexte du cours et le focus pour le {material}. Ajoute si utile une question directrice, un objectif d'apprentissage ou des exigences particulières."
      }
    }
  }
}
